module.exports = __webpack_public_path__ + "media/images/img-realestate-11-a908c44a.png";